import { isDiff } from './object-utils/object-utils';

export function isSolutionFilesDiff(oVal, nVal, k) {
  if (k === 'files') {
    return (
      !oVal !== !nVal ||
      oVal.length !== nVal.length ||
      oVal.some((of, idx) => !of.encrypted && isDiff(of, nVal[idx]))
    );
  } else {
    return isDiff(oVal, nVal, k);
  }
}
